var _style, _ellipse, _ellipse2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#6181B6;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#000004;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 127.1782,
    cy: -67.79,
    r: 69.6686,
    gradientTransform: "matrix(0.463 0 0 -0.463 -43.8236 -15.0253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4C6B97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 24.9,
    cy: 24.7,
    rx: 24.6,
    ry: 12.9
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 24.9,
    cy: 24.7,
    rx: 23.6,
    ry: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.7,28.6l1.2-6c0.3-1.4,0-2.4-0.7-3c-0.7-0.6-1.8-0.9-3.5-0.9h-2l0.6-3c0-0.1,0-0.2-0.1-0.3 c-0.1-0.1-0.2-0.1-0.3-0.1H22c-0.2,0-0.3,0.1-0.4,0.3l-1.2,6.4c-0.1-0.7-0.4-1.3-0.8-1.8c-0.8-0.9-2.1-1.4-3.9-1.4h-5.4 c-0.2,0-0.3,0.1-0.4,0.3l-2.5,13c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1h2.8c0.2,0,0.3-0.1,0.4-0.3l0.6-3.1h2.1 c1.1,0,2-0.1,2.7-0.3c0.7-0.2,1.4-0.7,2-1.2c0.5-0.4,0.9-0.9,1.2-1.5l-0.5,2.6c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1h2.8 c0.2,0,0.3-0.1,0.4-0.3l1.4-7.1H26c0.8,0,1.1,0.2,1.1,0.2c0.1,0.1,0.2,0.3,0,1L26,28.5c0,0.1,0,0.2,0.1,0.3 c0.1,0.1,0.2,0.1,0.3,0.1h2.9C29.5,28.9,29.6,28.8,29.7,28.6z M16.7,23.6c-0.2,0.9-0.5,1.6-1,1.9c-0.5,0.4-1.3,0.6-2.3,0.6h-1.2 l0.9-4.6h1.6c1.2,0,1.7,0.2,1.9,0.5C16.8,22.2,16.8,22.8,16.7,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.6,20.1c-0.8-0.9-2.1-1.4-3.9-1.4h-5.4c-0.2,0-0.3,0.1-0.4,0.3l-2.5,13c0,0.1,0,0.2,0.1,0.3 c0.1,0.1,0.2,0.1,0.3,0.1h2.8c0.2,0,0.3-0.1,0.4-0.3l0.6-3.1h2.1c1.1,0,2-0.1,2.7-0.3c0.7-0.2,1.4-0.7,2-1.2 c0.5-0.5,0.9-1,1.2-1.5c0.3-0.6,0.5-1.2,0.7-1.8C42.7,22.3,42.5,21,41.6,20.1z M38.7,23.6c-0.2,0.9-0.5,1.6-1,1.9 c-0.5,0.4-1.3,0.6-2.3,0.6h-1.2l0.9-4.6h1.6c1.2,0,1.7,0.2,1.9,0.5C38.8,22.2,38.9,22.8,38.7,23.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.7,21.1c1.1,0,1.8,0.2,2.1,0.6s0.4,1.1,0.2,2c-0.2,1-0.6,1.7-1.1,2.1c-0.6,0.4-1.4,0.6-2.5,0.6h-1.7 l1.1-5.4H14.7z M7.8,32h2.8l0.7-3.4h2.4c1.1,0,1.9-0.1,2.6-0.3c0.7-0.2,1.3-0.6,1.9-1.1c0.5-0.4,0.9-0.9,1.2-1.4 c0.3-0.5,0.5-1.1,0.6-1.7c0.3-1.5,0.1-2.7-0.7-3.6S17.4,19,15.7,19h-5.4L7.8,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.1,15.6h2.8L24.2,19h2.5c1.6,0,2.6,0.3,3.2,0.8c0.6,0.6,0.8,1.4,0.5,2.7l-1.2,6h-2.8l1.1-5.7 c0.1-0.7,0.1-1.1-0.1-1.3c-0.2-0.2-0.7-0.4-1.4-0.4h-2.2l-1.4,7.4h-2.8L22.1,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.7,21.1c1.1,0,1.8,0.2,2.1,0.6c0.4,0.4,0.4,1.1,0.2,2c-0.2,1-0.6,1.7-1.1,2.1c-0.6,0.4-1.4,0.6-2.5,0.6 h-1.7l1.1-5.4H36.7z M29.8,32h2.8l0.7-3.4h2.4c1.1,0,1.9-0.1,2.6-0.3s1.3-0.6,1.9-1.1c0.5-0.4,0.9-0.9,1.2-1.4 c0.3-0.5,0.5-1.1,0.6-1.7c0.3-1.5,0.1-2.7-0.7-3.6c-0.7-0.9-1.9-1.3-3.6-1.3h-5.4L29.8,32z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.4c7b46c0dbe480f127dfc2524300ced6.svg";
export { ForwardRef as ReactComponent };